var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F27D42;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,480h384c35.3,0,64-28.7,64-64V160c0-35.3-28.7-64-64-64H298.5c-17,0-33.3-6.7-45.3-18.7l-26.5-26.6 c-12-12-28.3-18.7-45.3-18.7H64C28.7,32,0,60.7,0,96v320C0,451.3,28.7,480,64,480z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSolid);
export default __webpack_public_path__ + "static/media/folder-solid.555e8a9277858dd02aa170743ff88bfb.svg";
export { ForwardRef as ReactComponent };